@for (
  estimate of estimates();
  track estimate.vendorId ?? estimate.estimationsId ?? $index
) {
  <app-quote-card
    [order]="order()"
    [estimate]="estimate"
    [orderDeadline]="orderDeadline()"
    [cancellationReason]="estimate.cancellationReason ?? null"
    [readonlyMode]="true"
  />
}
